import React from "react";
import { Table, Image } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import nodataimage from "../../assets/nodataimage.svg";

/**
 * Compact list table shared by every place that used to render entity cards
 * (students, teachers, classes, groups). Matches the exercise list tables so
 * the whole app reads the same.
 *
 * columns: [{ key, label, width?, className?, render(item), skeleton? }]
 */
const EntityTable = ({
  columns = [],
  items = [],
  loading,
  loadingRows = 4,
  emptyLabel,
  onRowClick,
  rowKey = (item, i) => item?._id || i,
}) => {
  const { t } = useTranslation();
  // Callers sometimes hold a non-array before their fetch resolves, so never
  // trust the prop's shape — an empty list is always a safe render.
  const rows = Array.isArray(items) ? items : [];

  return (
    <div
      className="bg-white entity-table-wrap"
      style={{
        borderRadius: "10px",
        boxShadow: "rgba(100, 100, 111, 0.15) 0px 4px 20px 0px",
        overflowX: "auto",
      }}
    >
      <Table hover className="mb-0 align-middle">
        <thead>
          <tr style={{ fontSize: "13px", color: "#8c8c8c" }}>
            {columns.map((c) => (
              <th
                key={c.key}
                className={c.thClassName || "py-3 fw-semibold"}
                style={c.width ? { width: c.width } : undefined}
              >
                {t(c.label)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: loadingRows }).map((_, i) => (
              <tr key={i}>
                {columns.map((c) => (
                  <td key={c.key} className="py-3">
                    {c.skeleton || <Skeleton width="70%" />}
                  </td>
                ))}
              </tr>
            ))
          ) : rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center py-5">
                <Image src={nodataimage} />
                <h5 className="mt-2 text-secondary">
                  {emptyLabel || t("No Results Found")}
                </h5>
              </td>
            </tr>
          ) : (
            rows.map((item, i) => (
              <tr
                key={rowKey(item, i)}
                onClick={onRowClick ? () => onRowClick(item) : undefined}
                style={onRowClick ? { cursor: "pointer" } : undefined}
              >
                {columns.map((c) => (
                  <td
                    key={c.key}
                    className={c.className || "py-3"}
                    onClick={
                      c.stopRowClick ? (e) => e.stopPropagation() : undefined
                    }
                  >
                    {c.render(item)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default EntityTable;
